import { useNavigate } from 'react-router-dom'
import { Box } from '@material-ui/core'
import { ROUTES } from '../../../../constants'
import { IInvoice } from 'models/invoices.models'
import CFDIFinderContainer from 'containers/Invoices/NewCFDI/CFDIFinderContainer/CFDIFinderContainer'

const NewCreditNoteScreen = () => {
  const navigate = useNavigate()

  const handleOnSelect = (invoice: IInvoice) => {
    const { idCfdi } = invoice
    idCfdi && navigate(ROUTES.ADD_CREDIT_NOTE.replace(':invoice', `${idCfdi}`))
  }
  return (
    <Box width="100%" paddingX={8}>
      <CFDIFinderContainer
        onSelect={handleOnSelect}
        title="Nueva nota de crédito"
        subtitle="Selecciona la factura a la cual se le aplicará la nota de crédito:"
      />
    </Box>
  )
}

export default NewCreditNoteScreen
